import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'


const CityPairExcelTable = (props) => {
    const { tableData, filters, loginData } = props
    const columnTable = [
        { headerName: 'Service Type ID', field: 'ServiceTypeID', headerSx: { width: "120px" }, inputField: false },
        { headerName: 'Service Type', field: 'ServiceType', headerSx: { width: "120px" }, inputField: false },
        { headerName: 'Consignment ID Type', field: 'ConsignmentSubTypeID', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Consignment Type', field: 'SubType', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Source City Name', field: 'FromCityName', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Destination City Name', field: 'ToCityName', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Freight Rate', field: 'Rate', headerSx: { width: "140px" }, inputField: true },
        { headerName: 'Local Freight Rate', field: 'LocalRate', headerSx: { width: "140px" }, inputField: true },
        { headerName: 'ETA Days', field: 'ETADays', headerSx: { width: "140px" }, inputField: true },
    ]
    return (
        <>
            <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight: '54vh' }}>

                <Table
                    id='cityPairExelTbl'
                    stickyHeader
                    size="small"
                    aria-label="a dense table"
                    sx={{
                        display: 'none',
                        '&.MuiTableCell-root': {
                            padding: '6px 8px!important',
                        },
                    }}
                >
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            <TableCell
                                className="reportTD"
                                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
                                colSpan={Math.floor(columnTable?.length / 2)}

                            >
                                <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>City Pair Rate Matrix</h3>
                            </TableCell>
                            <TableCell
                                className="reportTD"
                                style={{ fontWeight: 'bold', fontSize: '14px', fontWeight: '500', textAlign: 'right' }}
                                colSpan={Math.floor(columnTable?.length / 2)}

                            >
                                <h3 style={{ paddingLeft: '17px', fontFamily: 'Roboto', fontSize: '18px' }}>Company Name : {loginData.strCompanyName}</h3>
                            </TableCell>
                        </TableRow>
                        <TableRow ><TableCell colSpan={columnTable?.length}></TableCell></TableRow>
                        <TableRow>
                            <TableCell key={`CityHeader-1}`}
                                colSpan={Math.floor(columnTable?.length / 2)}
                                style={{
                                    backgroundColor: '#DAEDFE',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#444',
                                    height: '36px',
                                    whiteSpace: 'pre',
                                    padding: '6px',
                                    textAlign:'left'
                                }}>
                                Source City
                            </TableCell>
                            <TableCell key={`CityHeader-2}`}
                                colSpan={Math.floor(columnTable?.length / 2)}
                                style={{
                                    backgroundColor: '#DAEDFE',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    color: '#444',
                                    height: '36px',
                                    whiteSpace: 'pre',
                                    padding: '6px',
                                    textAlign:'left'
                                }}>
                                Destination City
                            </TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(columnTable?.length / 2)}
                            >
                                {filters?.sourceCity?.CityName}
                            </TableCell>
                            <TableCell
                                className="ReportItemHead"
                                style={{
                                    fontWeight: 'bold', color: 'black', fontSize: '16px', fontWeight: '500', textAlign: 'left', borderRight: '1px solid #ccc'
                                }}
                                colSpan={Math.floor(columnTable?.length / 2)}
                            >
                               {filters?.destinationCity?.CityName}
                            </TableCell>
                        </TableRow>
                        <TableRow ><TableCell colSpan={columnTable?.length}></TableCell></TableRow>
                    </TableHead>
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            <TableCell colSpan={columnTable?.length} style={{
                                backgroundColor: '#BFE1FF',
                                fontSize: '14px',
                                fontWeight: '600',
                                color: '#444',
                                height: '40px',
                                textAlign: 'left'
                            }}>
                                Consignment Type: {filters?.consignmentType?.name}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            {columnTable?.map((col, index) => (
                                <TableCell key={`CityHeader-${index}`} style={{
                                    ...col.headerSx,
                                    backgroundColor: '#DAEDFE',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    color: '#444',
                                    height: '40px'
                                }}>
                                    {col.headerName}
                                </TableCell>
                            ))}

                        </TableRow>

                    </TableHead>
                    {tableData?.length > 0 ? <TableBody>
                        {tableData?.map((val, index) => (
                            <TableRow key={`CityPairDataCol-${index}`}>
                                {columnTable.map((col, index1) => (
                                    <TableCell
                                        key={`CityPairDataCol-${index}-${index1}`}
                                        style={{
                                            ...col.headerSx,
                                            height: '40px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#444',
                                        }}
                                    >
                                        {val?.[col.field]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody> :
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={columnTable?.length}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginTop: '20px',
                                            marginBottom: '20px',
                                            color: 'red',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <span>No Results Found For The Selected Filters.</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableBody>}
                </Table>
            </TableContainer>
        </>
    )
}

export default CityPairExcelTable
